module.exports = __webpack_public_path__ + "static/media/environment-canada.20e81f60.png";